import { App } from 'vue';

import MyButton from '@/components/MyButton.vue';
import FilterSelect from '@/components/filter-select/FilterSelect.vue';
import FilterSelectMulti from '@/components/filter-select/FilterSelectMulti.vue';
import Datepicker from '@/components/Datepicker/Datepicker.vue';

export default function registerGlobalComponents(app: App<Element>): void {
    app.component('FilterSelect', FilterSelect);
    app.component('FilterSelectMulti', FilterSelectMulti);
    app.component('Datepicker', Datepicker);
    app.component('MyButton', MyButton);
}
